import Axios, { CancelTokenSource } from "axios";
import getApiEndpoint from "../../../../services/apiEndpoint";
import http from "../../../../services/httpService";
import { ServerEquipment } from "../../../../types/newPriceTypes";
import { pickNameListFromObj } from "../../../../utilities/objectUtil";
import { isValidNum } from "../../../../utilities/typeGuard";
import { QueryData } from "./marketPlace";
import {
  Advert, CatalogWarning, WarningTarget, WarningHistoryEntry,
  BrowseOption, BrowseOptionParams,
  EnrichmentCompletedPayload,
  PaginatedAdverts
} from "./types";
// import { ServerEquipment } from "../../newPriceManager/types";

const apiEndpoint = `${getApiEndpoint()}/adCatalog`;

export function updateCatalogWarning(target: WarningTarget, active: boolean, reason: string) {
  return http.put<{ data: CatalogWarning }>(`${apiEndpoint}/warnings`, { ...target, active, reason });
}

export function getCatalogWarningHistory(target: WarningTarget) {
  return http.get<{ data: WarningHistoryEntry[] }>(`${apiEndpoint}/warnings/history`, { params: target });
}




// const IS_DEV_MODE = process.env.NODE_ENV === 'development'
// const advertEntriesCache = createCacheLRU<AxiosResponse<{ data: Advert[] }>>(30, 900_000)
const cancelRef = { current: null as CancelTokenSource | null }
export async function findEntries({ filters, pagination, sorter }: QueryData) {
  cancelRef.current?.cancel("New request started, aborting old one.")
  cancelRef.current = Axios.CancelToken.source()

  // @ts-expect-error type mismatch between string and number
  filters.priceType = filters.priceType === '__ALL__' ? undefined : filters.priceType;

  const searchParams = new URLSearchParams()
  const standardFields = pickNameListFromObj(filters, [
    'type', 'manufacturer', 'model', 'variant', 'body', 'fuel', 'gearbox', 'status', 'priceType'
    // 'searchDate',
  ])
  if (filters.searchDate) {
    searchParams.set(`searchDate`, filters.searchDate)
  }
  if (filters.search) {
    searchParams.set("filter[q]", filters.search)
  }
  if (filters.priceType) {
    searchParams.set("priceType", filters.priceType.toString())
  }
  for (const [key, val] of Object.entries(standardFields)) {
    if (!val && !isValidNum(val)) continue;
    searchParams.set(`filter[${key}]`, val.toString())
  }
  if (filters.regYearFrom || filters.regYearTo) {
    searchParams.set("filter[firstRegDate]", `${filters.regYearFrom || ""}|${filters.regYearTo || ""}`)
  }
  if (filters.mileageFrom || filters.mileageTo) {
    searchParams.set("filter[mileage]", `${filters.mileageFrom || ""}|${filters.mileageTo || ""}`)
  }
  if (filters.priceFrom || filters.priceFrom) {
    searchParams.set("filter[price]", `${filters.priceFrom || ""}|${filters.priceTo || ""}`)
  }
  if (filters.horsePowerFrom || filters.horsePowerTo) {
    searchParams.set("filter[horsePower]", `${filters.horsePowerFrom || ""}|${filters.horsePowerTo || ""}`)
  }
  // if (filters.engineSizeFrom || filters.engineSizeTo) {
  //   searchParams.set("filter[engineSize]", `${filters.engineSizeFrom || ""}|${filters.engineSizeTo || ""}`)
  // }

  if (pagination) {
    searchParams.set("per_page", (pagination.perPage ?? 50).toString())
    searchParams.set("page", (pagination.page ?? 1).toString())
  }

  if (sorter && sorter.column) {
    const prefix = sorter.order === 'descend' ? "-" : ""
    searchParams.set("sort", `${prefix}${sorter.column.dataIndex?.toString() ?? ""}`)
  }

  const query = searchParams.toString()
  return await http.get<PaginatedAdverts | { data: { message: string } }>(`${apiEndpoint}/findEntries?${query}`, {
    cancelToken: cancelRef.current?.token ?? undefined
  })
}
// export async function findEntries(params: FindEntriesRequest) {
//   let cacheKey = "";
//   if (IS_DEV_MODE) {
//     cacheKey = serializeAdvertCatalogFilters(params)
//     const cachedResponse = advertEntriesCache.get(cacheKey)
//     if (cachedResponse) {
//       return cachedResponse
//     }
//   }
//
//   const searchParams = new URLSearchParams()
//   for (const [key, val] of Object.entries(params)) {
//     if (!val && !isValidNum(val)) continue;
//     if (Array.isArray(val) && val.length > 0) {
//       val.forEach(item => {
//         searchParams.append(`${key}[]`, String(item))
//       })
//
//     } else {
//       searchParams.set(key, String(val))
//     }
//   }
//
//   const query = searchParams.toString()
//   const response = await http.get<{ data: Advert[] }>(`${apiEndpoint}/findEntries?${query}`)
//
//   if (IS_DEV_MODE) {
//     advertEntriesCache.set(cacheKey, response)
//   }
//
//   return response
// }


// const advertModelBrowserCache = createCacheLRU<AxiosResponse<{ data: BrowseOption[] }>>(30, 180_000)
export async function browseAdvertOptions(values: BrowseOptionParams) {
  // const cacheKey = JSON.stringify(values)
  // const cachedResponse = advertModelBrowserCache.get(cacheKey)
  // if (cachedResponse) {
  //   return cachedResponse
  // }
  const searchParams = new URLSearchParams()

  if (values.searchDate) {
    searchParams.set("searchDate", values.searchDate)
  }
  if (values.type) {
    searchParams.set("type", values.type)
  }
  if (values.manufacturer) {
    searchParams.set("make", values.manufacturer)
  }
  if (values.model) {
    searchParams.set("model", values.model)
  }
  if (values.variant) {
    searchParams.set("variant", values.variant)
  }

  const query = searchParams.toString()
  const response = await http.get<{ data: BrowseOption[] | { message: string } }>(`${apiEndpoint}/browseOptions?${query}`);
  // advertModelBrowserCache.set(cacheKey, response)
  return response

}


// return [
//     'payloads' => 'required|array',
//     'payloads.*.advertId' => 'required|string',
//     'payloads.*.identifierCode' => 'sometimes|nullable|string',
//     'payloads.*.priceDate' => 'sometimes|nullable|date',
//     'payloads.*.forCommercial' => 'sometimes|nullable|bool',
//     'payloads.*.forceRefresh' => 'sometimes|nullable|bool',
// ];
type RequestEnrichmentPaylaod = {
  payloads: {
    advertId: string;
    identifierECode: string;
    priceDate?: string | null;
    forCommercial?: boolean | null;
    forceRefresh?: boolean | null;
    sync?: boolean;
  }[]
}
export function requestEnrichment(payload: RequestEnrichmentPaylaod) {
  return http.post<{ data: { [advertId: string]: EnrichmentCompletedPayload } }>(`${apiEndpoint}/requestEnrichment`, payload);
}

/** This works the same way as requestEnrichment, except this uses AI to infer the enrichment
 * from the advert description, and this doesnt persist the result to the database. */
export function inferEnrichment(payload: RequestEnrichmentPaylaod) {
  return http.post<{ data: { [advertId: string]: EnrichmentCompletedPayload } }>(`${apiEndpoint}/inferEnrichment`, payload);
}

/**
 * @return status code 204
 * */
export function updateAdvertMotorAtlasId(payload: {
  adId: string;
  motorAtlasId: string;
}) {
  return http.post(`${apiEndpoint}/updateEntryMotorAtlasId`, payload);
}



// TODO: Implement this when it is fully finished from the backend
/**
 * @return status code 204
 * */
export function updateAdvertAugmentation(payload: {
  advertId: string,
  motorAtlasId: string,
  equipment: string[],
  manualEquipment?: null | ServerEquipment[],
}) {
  return http.post(`${apiEndpoint}/updateEntryAugmentation`, payload);
}


export function overrideAdvertVin(payload: {
  marketplaceEntry: string | number,
  vin: string,
}) {
  return http.post<Advert>(`${apiEndpoint}/overrideVin`, payload);
}
